module.exports = __webpack_public_path__ + "static/img/yf_02.560e145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_02.jpg
// module id = Jedy
// module chunks = 1